/* ==========================================================================
   Questionnaire
   ========================================================================== */

$('body').on('click', '.js-questionnaire-toggle', function () {
	$(this).siblings(".questionnaire__nav").toggleClass("is-active");
	if ($(this).attr('aria-expanded') === 'true') {
		$(this).attr('aria-expanded', 'false');
		$(this).siblings(".questionnaire__nav").attr("aria-hidden", "true");
	} else {
		$(this).attr('aria-expanded', 'true');
		$(this).siblings(".questionnaire__nav").attr("aria-hidden", "false");
	}
});

//Close question on click outside
$('body').on('click', '.js-questionnaire-close', function () {
	$(".questionnaire__nav").removeClass('is-active');
	$(".questionnaire__nav-button").attr('aria-expanded', 'false');
	$(".questionnaire__nav").attr("aria-hidden", "true");

	var questionnaireValue = $(this).parents(".questionnaire__nav-container").find("input:radio:checked").val();
	$(this).parents(".questionnaire__nav-container").find(".questionnaire__nav-button").html(questionnaireValue);
	updateQuestionnaire($(this));
});

$('body').on('change', '.questionnaire__radio', function (e) {
	$(this).parents(".questionnaire__nav-container").find(".questionnaire__nav-button").html(this.value);

	$(".questionnaire__nav").removeClass('is-active');
	$(".questionnaire__nav-button").attr('aria-expanded', 'false');
	$(".questionnaire__nav").attr("aria-hidden", "true");
	updateQuestionnaire($(this));
});

function updateQuestionnaire(thisObj) {
	var childOptions = thisObj.data("childoptions");
	var url = thisObj.data("url");
	var message = thisObj.data("message");
	var levelIdentifier = "";
	var defaultChildOption = null;


	//on level 1 change
	if (thisObj.attr('name') === "questionnaire-level1") {
		if (childOptions != null && childOptions.length > 0) {
			levelIdentifier = "questionnaire-level2";

			defaultChildOption = childOptions[0];
			var hasLevel3 = defaultChildOption.ItemType === "Level2" && defaultChildOption.Options !== null && defaultChildOption.Options !== 'undefined';

			updateDropdownOptions(levelIdentifier, childOptions);
			updateDefaultSelectedDropdownItem(levelIdentifier, defaultChildOption);

			levelIdentifier = "questionnaire-level3";
			if (hasLevel3) {
				var level3DefaultOption = defaultChildOption.Options[0];
				updateDropdownOptions(levelIdentifier, defaultChildOption.Options);
				updateDefaultSelectedDropdownItem(levelIdentifier, level3DefaultOption);
				$("#" + levelIdentifier).show();
				setButtonLink(level3DefaultOption.Url);
				setMessage(level3DefaultOption.Message);
				setLevel3Label(defaultChildOption.OptionsLabel);
			}
			else {
				$("#" + levelIdentifier).hide();
				setButtonLink(defaultChildOption.Url);
				setMessage(defaultChildOption.Message);
			}
		}
	}

	//on level 2 change
	else if (thisObj.attr('name') === "questionnaire-level2") {
		levelIdentifier = "questionnaire-level3";
		if (childOptions != null && childOptions.length > 0) {
			defaultChildOption = childOptions[0];

			updateDropdownOptions(levelIdentifier, childOptions);
			updateDefaultSelectedDropdownItem(levelIdentifier, defaultChildOption);
			$("#" + levelIdentifier).show();
			setButtonLink(defaultChildOption.Url);
			setMessage(defaultChildOption.Message);
			var title = thisObj.data("childquestion");
			setLevel3Label(title);
		}
		else {
			$("#" + levelIdentifier).hide();
			setButtonLink(url);
			setMessage(message);
		}
	}

	//on level 3 change
	else if (thisObj.attr('name') === "questionnaire-level3") {
		setButtonLink(url);
		setMessage(message);
	}
}

function updateDropdownOptions(levelIdentifier, childOptions) {
	var levelSelector = "." + levelIdentifier;
	$("li").remove(levelSelector);

	childOptions.forEach((option, index) => {
		var inputSelectorClass = "js-" + levelIdentifier + "-" + index;
		var liHtml = setListItemHtml(levelIdentifier, option, index, inputSelectorClass);
		$("ul" + levelSelector).append(liHtml);
		$("input." + inputSelectorClass).data("childoptions", option.Options);
	});
}

function setListItemHtml(levelIdentifier, option, index, inputSelectorClass) {
	var urlSegment = option.Title.replace(/\s+/g, '-').toLowerCase();
	var childQuestion = null;
	var checked = index === 0 ? "checked" : "";
	var url = "";
	var message = "";
	if (option.ItemType === "Url") {
		url = option.Url;
		message = option.Message;
	}
	else {
		childQuestion = option.OptionsLabel;
	}
	
	return `
		<li class="questionnaire__nav-list-item ` + levelIdentifier + `">
			<input
				type="radio"
				name="` + levelIdentifier + `"
				id="` + urlSegment + `"
				class="questionnaire__radio ` + inputSelectorClass + `"
				value="` + option.Title + `"
				data-childoptions=""
				data-childquestion="` + childQuestion + `"
				data-url="` + url + `"
				data-message="` + message + `"
				` + checked + `
			>
			<label for="` + urlSegment + `">` + option.Title + `</label>
		</li >
	`;
}

function setButtonLink(url) {
	$("#js-sitehelp-btn").attr("href", url);
}

function setMessage(message) {
	var messageSelector = $("#js-sitehelp-message");
	messageSelector.hide();

	if (message !== null && typeof (message) !== "undefined" && message !== "") {
		messageSelector.text(message);
		messageSelector.show();
	}
}

function updateDefaultSelectedDropdownItem(levelIdentifier, option) {
	$(".js-questionnaire-toggle." + levelIdentifier).html(option.Title);
}

function setLevel3Label(title) {
	$(".js-question-label-questionnaire-level3").text(title);
}
